import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { tap } from "rxjs/operators";
import { Reference } from "../../reference/reference";
import { InventoryAdjustmentService } from "../inventory-adjustment.service";
import { NewInventoryAdjustment } from "../model/new-inventory-adjustment";
import { NewInventoryAdjustmentResult } from "../model/new-inventory-adjustment-result";

@Component({
  templateUrl: "./inventory-adjustment.component.html",
})
export class InventoryAdjustmentComponent {
  public error = false;
  public loading = false;
  public invalidComment = false;
  public invalidQuantity = false;

  public onCreate!: () => void;
  public reference!: Reference;
  public result!: NewInventoryAdjustmentResult;
  public newInventoryAdjustment = new NewInventoryAdjustment();

  constructor(
    public activeModal: NgbActiveModal,
    private inventoryAdjustmentService: InventoryAdjustmentService
  ) { }

  private validate(): boolean {
    var valid = true;

    if (this.newInventoryAdjustment.comment == undefined || this.newInventoryAdjustment.comment == "") {
      valid = false;
      this.invalidComment = true;
    }

    if (this.newInventoryAdjustment.quantity == undefined || this.newInventoryAdjustment.quantity == 0) {
      valid = false;
      this.invalidQuantity = true;
    }

    return valid;
  }

  public createInventoryAdjustment() {
    this.invalidComment = false;
    this.invalidQuantity = false;

    if (!this.validate()) {
      return;
    }

    this.loading = true;
    this.error = false;

    this.newInventoryAdjustment.isbn = this.reference.isbn;
    this.inventoryAdjustmentService.create(this.newInventoryAdjustment)
      .pipe(tap(result => this.result = result))
      .subscribe({
        next: _ => {
          this.loading = false;
          this.activeModal.close();
          this.onCreate();
        },
        error: e => {
          this.error = true;
          this.loading = false;
        }
      });
  }
}